import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HeaderView from '../views/HeaderView.vue'
import FooterView from '../views/FooterView.vue'

import CertificateView from '../views/CertificateView.vue'
import MainBiodesainView from '../views/MainBiodesainView.vue'
import MainInplantsView from '../views/MainInplantsView.vue'
import MainTypeView from '../views/MainTypeView.vue'
import MedGelView from '../views/MedGelView.vue'
import StandardLineView from '../views/StandardLineView.vue'
import UnderwearView from '../views/UnderwearView.vue'

// добавляем твои новые вьюхи
import SilimedView from '@/views/SilimedView.vue'
import InvoView from '@/views/InvoView.vue'
import PureView from '@/views/PureView.vue'
import HowToSuuitView from '@/views/HowToSuitView.vue'
import HowToWashView from '@/views/HowToWashView.vue'

const routes = [
  { path: '/', name: 'home', component: HomeView },
  { path: '/header', name: 'header', component: HeaderView },
  { path: '/footer', name: 'footer', component: FooterView },

  { path: '/certificate', name: 'certificate', component: CertificateView },
  { path: '/biodesain', name: 'biodesain', component: MainBiodesainView },
  { path: '/inplants', name: 'inplants', component: MainInplantsView },
  { path: '/type', name: 'type', component: MainTypeView },
  { path: '/medgel', name: 'medgel', component: MedGelView },
  { path: '/standardline', name: 'standardline', component: StandardLineView },
  { path: '/underwear', name: 'underwear', component: UnderwearView },

  // тут наши новые маршруты
  { path: '/silimed', name: 'silimed', component: SilimedView },
  { path: '/invo', name: 'invo', component: InvoView },
  { path: '/pure', name: 'pure', component: PureView },
  { path: '/howtosuit', name: 'howtosiut', component: HowToSuuitView },
  { path: '/howtowash', name: 'howtowash', component: HowToWashView },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// 🔥 фикс для внешних ссылок (например, Instagram)
router.beforeEach((to, from, next) => {
  if (to.fullPath.startsWith('http')) {
    window.open(to.fullPath, '_blank', 'noopener,noreferrer')
    return
  }
  next()
})

export default router
